module.exports = __webpack_public_path__ + "static/media/mobile-bg-layer-1.ee7f6f54.png";